// Auto-generated from the Civil Engineering rows in Copy of Staff Academic Particulars_.csv
// 37 unique staff records; duplicate Abdullahi Isah submission consolidated using the later record.

export const CIVIL_STAFF_IMAGE_BASE = "/images/departments/civil-engineering/staff";

export const civilEngineeringStaff = [
  {
    id: 1,
    title: "Engr",
    name: "Abdullahi Nuhu",
    rank: "Senior Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/abdullahi-nuhu.jpg`,
    qualifications: ["B.Eng, M.Eng (Futminna)"],
    professionalQualifications: ["MNSE"],
    publications: "12",
    researchInterests: ["Water Resource and Environmental Engineering", "Water Resources", "Environmental Engineering", "Modelling and Analysis"],
    specialties: ["BEng Water Resources and Environmental Engineering", "MEng Water Resources and Environmental Engineering"],
    awards: ["Research Grants"],
    email: "Abdullahi.nuhu@fedpolybida.edu.ng",
    phone: "07030841993",
    driveFileId: "1a8mHRn5nycixchS_VFk4I9N339LDqE4Y",
    slug: "abdullahi-nuhu",
  },
  {
    id: 2,
    title: "Engr.",
    name: "Yabagi Isah Abdullahi",
    rank: "PRINCIPAL LECTURER",
    image: `${CIVIL_STAFF_IMAGE_BASE}/yabagi-isah-abdullahi.jpg`,
    qualifications: ["MSc (ABU Zaria)"],
    professionalQualifications: ["NATE", "MNSE", "COREN"],
    publications: "20",
    researchInterests: ["TRANSPORTATION", "MATERIALS", "CONCRETE"],
    specialties: ["HND, and PGD  (Civil Engineering)", "MSc. (Transportation Engineering)"],
    awards: ["NRF Research Grant/ Smart Healing of Nano-graphene/parlite of Sandcrete Block"],
    email: "abdullahi.yabagi@fedpolybida.edu.ng",
    phone: "08033566533",
    driveFileId: "1BHwtGfe3ptqJdP31Ba7RVP5trZ-MmJrR",
    slug: "yabagi-isah-abdullahi",
  },
  {
    id: 3,
    title: "Engr",
    name: "Mohammed Badamasi Suleiman",
    rank: "LECTURER III",
    image: `${CIVIL_STAFF_IMAGE_BASE}/mohammed-badamasi-suleiman.jpg`,
    qualifications: ["B.Eng (CIVIL ENGINEERING) ABU ZARIA"],
    professionalQualifications: ["COREN"],
    publications: "4",
    researchInterests: ["Structure", "Highway", "Material", "Material"],
    specialties: ["B.Eng Civil Engineering"],
    awards: [],
    email: "mohammed.badamasi@fedpolybida.edu.ng",
    phone: "08032542598",
    driveFileId: "1znDcmTk_9jEW_CMTuq-gnbUZGOMvYeSl",
    slug: "mohammed-badamasi-suleiman",
  },
  {
    id: 4,
    title: "Engr",
    name: "Mohammed Yewa",
    rank: "Chief Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/mohammed-yewa.jpg`,
    qualifications: ["HND, Beng, Meng  Phd(inview)"],
    professionalQualifications: ["MNSE", "COREN."],
    publications: "10",
    researchInterests: ["Material Engineering", "Construction Materials"],
    specialties: ["Civil Engineering", "Structural Engineering", "Structural Engineering"],
    awards: [],
    email: "Mohammedyewa@fedpolybida.edu.ng",
    phone: "09068515663",
    driveFileId: "18isICKVx55l4PpEv8yFwpChWFPtzN1d6",
    slug: "mohammed-yewa",
  },
  {
    id: 5,
    title: "Engr.",
    name: "Ndaiji Amali Umar",
    rank: "Senior Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/ndaiji-amali-umar.jpg`,
    qualifications: ["(B.Eng  (FUT Minna), Msc (ABU Zaria))"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "",
    researchInterests: ["Concrete materials", "Structural Design"],
    specialties: ["(B.Eng  (Civil Engineering), Msc (Structural engineering)", "M.Sc Structure"],
    awards: [],
    email: "ndaiji.amali@fedpolybida.edu.ng",
    phone: "07039498891",
    driveFileId: "17HMvvTWohmt7gXyoPZs47jn85HsQZwDA",
    slug: "ndaiji-amali-umar",
  },
  {
    id: 6,
    title: "Engr",
    name: "MUSA MUHAMMAD",
    rank: "Chief Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/musa-muhammad.jpg`,
    qualifications: ["B.Eng(BUK) MSc(ABU)"],
    professionalQualifications: ["MNSE"],
    publications: "Over 50",
    researchInterests: ["Water Resources and Environmental Engineering", "Civil Engineering", "Environmental management"],
    specialties: ["B.Eng (Civil Engineering)", "M.Sc ( Water Resources Engineering)"],
    awards: [],
    email: "musa.mohammed@fedpolybida.edu.ng",
    phone: "07034612248",
    driveFileId: "1TaLQ2nGcvqjsccyHC09oRUqYnjW3MDyy",
    slug: "musa-muhammad",
  },
  {
    id: 7,
    title: "",
    name: "Bala Hassan",
    rank: "Senior Instructor",
    image: "/images/default-staff.jpg",
    qualifications: ["ND fed poly Bida  and  HND  fed poly kaduna"],
    professionalQualifications: ["Nil"],
    publications: "Nil",
    researchInterests: ["Nil", "Nil", "Nil", "Nil", "Nil", "Nil", "Nil", "Nil", "Nil", "Nil"],
    specialties: ["HND(civil Engineering)", "HND(transportation Engineering"],
    awards: ["Nil"],
    email: "(Bala Hassan @fedpolybida.edu.ng)",
    phone: "08060393259",
    driveFileId: "1PBGqPARySIrs6E0I_ydexgWr3syaqk90",
    slug: "bala-hassan",
  },
  {
    id: 8,
    title: "Mr",
    name: "Aminu Danasabe Usman Doko",
    rank: "Chief Technologist",
    image: `${CIVIL_STAFF_IMAGE_BASE}/aminu-danasabe-usman-doko.jpg`,
    qualifications: ["HND CIVIL Engrg Structures (FPBida), PGD Geology (IBBU Lapai)"],
    professionalQualifications: ["NATE"],
    publications: "2 conference paper's and 1 journal",
    researchInterests: ["Civil Engineering general", "General civil engineering"],
    specialties: ["General Civil Engineering"],
    awards: [],
    email: "usman.dan-asabe@fedpolybida.edu.ng",
    phone: "0806 028 2833",
    driveFileId: "1ljDg6_OamNlIJzVkY0Obhf20eAMO4uSa",
    slug: "aminu-danasabe-usman-doko",
  },
  {
    id: 9,
    title: "Technologist",
    name: "Manyahya Alhaji Shehu",
    rank: "Assistant Chief technologist",
    image: `${CIVIL_STAFF_IMAGE_BASE}/manyahya-alhaji-shehu.jpg`,
    qualifications: ["ND, HND,B. Engineering"],
    professionalQualifications: ["NATE"],
    publications: "",
    researchInterests: ["Evaluation of water treatment sludge stablize laterite soil for road construction", "Investigation into coconut fibre ash as a partial replacement of OPC", "Effect of ceramics and calcium carbide waste on the geotechnical properties of cement stablize clay soil", "Effect of ground but husk ash on the compressive strength of concrete work partial replacement of cement with (GHA) shell as a light weight material for the production of light weight concrete", "Factors lead to the causes of persistent failure of pavement", "Effects of aggregate shapes on the workability of Concrete", "Soil stabilisation using lime and Cement", "Stabilisation of clay-sand for subgrade", "Assessment of bearing capacity", "Stabilisation of weak soil using maize husk ash"],
    specialties: ["Geotechnical Engineering", "Geotechnical Engineering", "MSc (Geotechnical Engineering) K.I.V"],
    awards: [],
    email: "manyahyaalhajishehu@gmail.com",
    phone: "08066179691",
    driveFileId: "1rgkXQUMAEceP9b4O79fHyu1Ie7CypSpH",
    slug: "manyahya-alhaji-shehu",
  },
  {
    id: 10,
    title: "Tgst.",
    name: "DOKOCHI NDANUSA",
    rank: "Chief Instructor",
    image: `${CIVIL_STAFF_IMAGE_BASE}/dokochi-ndanusa.jpg`,
    qualifications: ["Bsc"],
    professionalQualifications: ["NATE"],
    publications: "Five (3)",
    researchInterests: ["Structural Analysis, Design and Optimisation.", "Sustainable Construction and Circular Economy.", "Alternative/Recycled Construction Materials materials.", "Circular Economy and Construction-Waste Recycling.", "Climate-Resilient and Low-Carbon Infrastructure.", "Reliability and Performance of Construction Materials.", "Advanced and High-Performance Concrete.", "Material Curability and Service-Life Prediction.", "Green Building Materials and Sustainable Infrastructure.", "Reliability-Based Design of Timber Structures."],
    specialties: ["B.Eng(Civil Engineering)"],
    awards: [],
    email: "dokochi.ndanusa@fedpolybida.edu.ng",
    phone: "08032901783",
    driveFileId: "1-ySqOAEkBgpuaq8smpGiiMP23qRBcPOz",
    slug: "dokochi-ndanusa",
  },
  {
    id: 11,
    title: "Mall.",
    name: "Dzukogi Abubakar Alhassan",
    rank: "Senior technologist",
    image: "/images/default-staff.jpg",
    qualifications: ["HND(FPB)"],
    professionalQualifications: ["Coren"],
    publications: "1",
    researchInterests: ["Pavement recycling: Using recycled asphalt and industrial waste in sustainable road construction", "Soil stabilization: Advanced techniques for weak or problematic soils", "Hydrology and climate: Flood Prediction and Stormwater Management Models and hydro-climatology."],
    specialties: ["Structure"],
    awards: [],
    email: "alhassandzukogi@fedpolybida.edu.ng",
    phone: "0814 941 6554",
    driveFileId: "1ZFcZxENx832jNv5k-Tcnad0r4_tda8A1",
    slug: "dzukogi-abubakar-alhassan",
  },
  {
    id: 12,
    title: "Engr Dr",
    name: "Sani Mohammed Bida",
    rank: "Chief Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/sani-mohammed-bida.jpg`,
    qualifications: ["B. Eng (BUK), MSc (University Putra Malaysia), PhD (University Putra Malaysia)"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "25-30",
    researchInterests: ["Structures", "Materials"],
    specialties: ["Civil/Structural Engineering"],
    awards: [],
    email: "sani.mohammed@fedpolybida.edu.ng",
    phone: "08077742416",
    driveFileId: "1ieTqj5dSqAwCDg8WWl-kg0426Y8wZjLH",
    slug: "sani-mohammed-bida",
  },
  {
    id: 13,
    title: "Engr",
    name: "Saidu Abubakar Sadiq",
    rank: "Lecturer III",
    image: `${CIVIL_STAFF_IMAGE_BASE}/saidu-abubakar-sadiq.jpg`,
    qualifications: ["B.Eng (ABU Zaria, 2014), M.Eng(FUT Minna, 2023)"],
    professionalQualifications: ["COREN", "MNSE"],
    publications: "Nil",
    researchInterests: ["Public transit optimization", "Pavement Engineering", "Digital Twins of highways for predictive maintenance and traffic flow optimization", "Soil stabilization using recycled materials or enzymes (instead of cement/lime)", "Nil", "Nil", "Nil", "Nil", "Nil", "Nil"],
    specialties: ["B.Eng (Civil Engineering)", "M.Eng (Transportation Engineering)", "Nil"],
    awards: ["Nil"],
    email: "Saidu.abubakarsdiq@fedpolybida.edu.ng",
    phone: "08134681868",
    driveFileId: "1uIfUvJ41-TTaM3NIJkiJG1HDXpL6ec_x",
    slug: "saidu-abubakar-sadiq",
  },
  {
    id: 14,
    title: "Engr. Dr.",
    name: "Muhammad Nda",
    rank: "Senior Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/muhammad-nda.jpg`,
    qualifications: ["BEng, MEng (FUT Minna), PhD (UTHM)"],
    professionalQualifications: ["COREN"],
    publications: "29",
    researchInterests: ["Water Resources", "Environmental Engineering", "Sedimentation & Erosion", "Climate Change"],
    specialties: ["B. Eng Civil Engineering", "M.Eng. Civil Engineering ( Water Resources & Environmental Engineering)", "PhD Civil Engineering"],
    awards: [],
    email: "nda.muhammad@fedpolybida.edu.ng",
    phone: "08022226136",
    driveFileId: "1sKwlTEwQC-HDJRMmyyQbhE--co5bQzt6",
    slug: "muhammad-nda",
  },
  {
    id: 15,
    title: "Engr.",
    name: "Musa Yakubu",
    rank: "Principal Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/musa-yakubu.jpg`,
    qualifications: ["B.Eng. (FUT Minna), M.Sc. (ABU Zaria)"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "20",
    researchInterests: ["Highway and Transportation", "Materials."],
    specialties: ["B. Eng (Civil Engineering)", "M.Sc. (Civil engineering)"],
    awards: ["Nil"],
    email: "musa.yakubu@fedpolybida.edu.ng",
    phone: "08060695522",
    driveFileId: "1vKrwRW3ghPqVqS94Y3E_0wrX_6PEDQtJ",
    slug: "musa-yakubu",
  },
  {
    id: 16,
    title: "ENGR,",
    name: "Ashafa Abdulkadir",
    rank: "Assistant chief Technology",
    image: `${CIVIL_STAFF_IMAGE_BASE}/ashafa-abdulkadir.jpeg`,
    qualifications: ["HND,B.ENG, Msc FUT Minna"],
    professionalQualifications: ["NATE", "COREN"],
    publications: "6",
    researchInterests: ["Water resources and environmental Enginneering", "Geotechnics", "Structures"],
    specialties: ["B.ENG Civil Engineering", "Msc Civil Engineering", "Phd Civil Engineering in view"],
    awards: [],
    email: "ashafaabdulkadirfedpolybida.edu.ng",
    phone: "08067960277",
    driveFileId: "1HkO0xISv40EwDstTcYPOvXAO-X3sHhZn",
    slug: "ashafa-abdulkadir",
  },
  {
    id: 17,
    title: "Engr.",
    name: "Ahmed Victor Itopa",
    rank: "Lecturer II",
    image: `${CIVIL_STAFF_IMAGE_BASE}/ahmed-victor-itopa.jpg`,
    qualifications: ["B.Eng"],
    professionalQualifications: ["COREN"],
    publications: "6 outstanding Publications",
    researchInterests: ["Water Resources and Environmental Engineering", "Irrigation Engineering", "Noise Pollution Engineering"],
    specialties: ["B.Eng (Civil Engineering)"],
    awards: [],
    email: "ahmed.itopavictor@fedpolybida.edu.ng",
    phone: "08100914818",
    driveFileId: "1wr4s5hOaASvL9a0wejr96AIRsXpbn2Et",
    slug: "ahmed-victor-itopa",
  },
  {
    id: 18,
    title: "Engr.",
    name: "Ma'ali Mohammed Jiya",
    rank: "Chief Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/maali-mohammed-jiya.jpg`,
    qualifications: ["M.Eng (FUT Minna)"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "Conferences: 20, Journal Publication: 19",
    researchInterests: ["Strength of Materials", "Concrete LightWeight Materials"],
    specialties: ["Civil engineering (Structures)"],
    awards: ["Best Dean of the year 2022"],
    email: "ma'ali.mohammed@fedpolybida.edu.ng",
    phone: "08036928124",
    driveFileId: "1ZH4uO1fc49y6OpHNCg_3vO-OkRWlUwz2",
    slug: "maali-mohammed-jiya",
  },
  {
    id: 19,
    title: "Tgst",
    name: "Aliyu Mohammed",
    rank: "Technologist II",
    image: "/images/default-staff.jpg",
    qualifications: ["HND Civil Engineering"],
    professionalQualifications: ["NATE"],
    publications: "3",
    researchInterests: ["Water Resources and Environmental Engineering", "Water Quality Analysis", "Water Resources"],
    specialties: ["HND WATER RESOURCES", "Process Engineering", "Civil Engineering Water option"],
    awards: ["Water Quality Evaluation Analysis"],
    email: "engraliyu1978@gmail.com",
    phone: "08065614486",
    driveFileId: "1Y6xv_wVpjvE03iiqRcwKu-7OBEvn1IGd",
    slug: "aliyu-mohammed",
  },
  {
    id: 20,
    title: "Mr",
    name: "Mohammed Baba Gozan",
    rank: "Chief Lab Assistant",
    image: "/images/default-staff.jpg",
    qualifications: ["WSCE"],
    professionalQualifications: ["Nate"],
    publications: "",
    researchInterests: ["Water Resources", "Water Resources"],
    specialties: ["Water Resources and Environmental Engineering", "WSCE"],
    awards: [],
    email: "Baba.mohammed@fedpolybida.edu.ng",
    phone: "07031201665",
    driveFileId: "1jvFFBp0ySJw4fTwYPP3L4LfcEHpM4YVS",
    slug: "mohammed-baba-gozan",
  },
  {
    id: 21,
    title: "Tgst",
    name: "Mammnan Saba Abdullahi",
    rank: "Technologist II",
    image: "/images/default-staff.jpg",
    qualifications: ["HND BUILDING TECHNOLOGY"],
    professionalQualifications: ["Nate"],
    publications: "5",
    researchInterests: ["Soil Mechanics", "Transportation Engineering", "Geomechanics"],
    specialties: ["HND BUILDING TECHNOLOGY", "Building Technology", "Engineering Technology"],
    awards: ["NATE CERT"],
    email: "Mammansaba123@gmail.com",
    phone: "08160925645",
    driveFileId: "1FND1T4QAXHP8EjXJIDjx9_O1eo10zfUO",
    slug: "mammnan-saba-abdullahi",
  },
  {
    id: 22,
    title: "Engr",
    name: "Jiya Gideon shabako",
    rank: "Senior lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/jiya-gideon-shabako.jpg`,
    qualifications: ["Msc unilorin"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "11",
    researchInterests: ["Highway engineering", "Highway engineering", "Transportation engineer", "Transportation engineer"],
    specialties: ["B.Eng(Civil)"],
    awards: ["M engr"],
    email: "giddyzion1@gmail.com",
    phone: "08030490734",
    driveFileId: "1vSRz46p5SRwYtsXVaae72-2fHlY1m6-D",
    slug: "jiya-gideon-shabako",
  },
  {
    id: 23,
    title: "Tgst",
    name: "Mohammed Ibrahim",
    rank: "Senior technologist",
    image: `${CIVIL_STAFF_IMAGE_BASE}/mohammed-ibrahim.jpg`,
    qualifications: ["HND FPB"],
    professionalQualifications: ["NATE"],
    publications: "2",
    researchInterests: ["Water resources and environmental engineering", "Civil engineering"],
    specialties: ["HND civil Engineering"],
    awards: [],
    email: "Mohammed19@fedpolybida",
    phone: "08030599399",
    driveFileId: "1QUBIlx_2G_6bX3aV5D-TSXu6HhbVQ1ef",
    slug: "mohammed-ibrahim",
  },
  {
    id: 24,
    title: "Mr",
    name: "Subair ismaila alabi",
    rank: "Lecturer 3",
    image: `${CIVIL_STAFF_IMAGE_BASE}/subair-ismaila-alabi.jpg`,
    qualifications: ["B.eng (Fut minna)"],
    professionalQualifications: ["Nil"],
    publications: "1",
    researchInterests: ["Structure", "Structure", "Structure", "Structure", "Structure", "Structure", "Structure", "Structure", "Structure", "High way"],
    specialties: ["Structure", "Structure", "Nil"],
    awards: ["B.Eng in Civil Engineering"],
    email: "alabigamma@gmail.com",
    phone: "07036732138",
    driveFileId: "1CDV_lU5xsnbl5iRVIlmwY8-OYWlCIZdQ",
    slug: "subair-ismaila-alabi",
  },
  {
    id: 25,
    title: "Engr.",
    name: "Umar Nuhu",
    rank: "Assistant Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/umar-nuhu.jpg`,
    qualifications: ["BEng, MEng (FUT Minna)"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "3",
    researchInterests: ["Sustainable Materials", "Structural Design."],
    specialties: ["BEng (Civil Engineering)", "MEng (Structural Engineering)", "PhD (Structural Engineering, In view)"],
    awards: ["Nill"],
    email: "Nill",
    phone: "08069750274 / 09078170712",
    driveFileId: "11EphUzA3-7Wc2ZksiP74ozgGk90esSg9",
    slug: "umar-nuhu",
  },
  {
    id: 26,
    title: "Engr",
    name: "Adamu",
    rank: "Senior",
    image: `${CIVIL_STAFF_IMAGE_BASE}/adamu.jpg`,
    qualifications: ["MEng FUTMINNA"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "About 20",
    researchInterests: ["Materials", "Design", "Development", "Materials"],
    specialties: ["B. Eng civil engineering", "MEng"],
    awards: ["Academic"],
    email: "AdamuYakub@fedpolybida.edu.ng",
    phone: "08030819303",
    driveFileId: "1Sj8SoI0j_eN73hYHO0aKQMqIhI4SvWc5",
    slug: "adamu",
  },
  {
    id: 27,
    title: "Dr.",
    name: "AHMED AHMED",
    rank: "Senior Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/ahmed-ahmed.jpg`,
    qualifications: ["B. Eng Civil ( BUK) M. Eng Structures (BUK) PhD Structures ( BUK)s"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "43",
    researchInterests: ["Material", "Concrete", "Structure"],
    specialties: ["B. Eng (Civil Engineering)", "M. Eng ( Structures)", "PhD (Structures)"],
    awards: [],
    email: "ahmed.ahmed@fedpolybida.edu.ng",
    phone: "+2348065460813",
    driveFileId: "1RSSSFiQbFITCsYweFOBdM3cKVuEFyLU3",
    slug: "ahmed-ahmed",
  },
  {
    id: 28,
    title: "Engr",
    name: "Mahmud Kudu",
    rank: "Assistant Chief Instructor",
    image: `${CIVIL_STAFF_IMAGE_BASE}/mahmud-kudu.jpg`,
    qualifications: ["ND (TFPB), HND (TFPB), B. Eng (FUT Minna), Msc (ABU Zaria), PhDs in view (Oye-Ekiti and ABU Zaria)"],
    professionalQualifications: ["MNICE", "MNATE", "MNSE", "COREN"],
    publications: "28",
    researchInterests: ["Geopolymer Concrete", "Cement Replacement in Concrete", "Rigid Pavement Using Geopolymer", "Construction Materials", "Water and Hydraulic Structures", "Erosion and Flooding", "Concrete and Cement Supplementary Materials.", "Rice Husk Ash and Metakaolin for Cement Replacement", "Kaolin and Eggshell Powder for Cement Replacement", "Metakaolin and Fly Ash for Concrete"],
    specialties: ["B. Eng (Civil Engineering)", "M.Sc (Civil Engineering)", "PhDs in view (Structures and Highway)"],
    awards: [],
    email: "kudu.mahmud@fedpolybida.edu.ng",
    phone: "+2347039281203",
    driveFileId: "1O2rJ6PwSTdWJvFYJE-W8EdPO5vpb1XnT",
    slug: "mahmud-kudu",
  },
  {
    id: 29,
    title: "Engr.",
    name: "Abdullahi Isah",
    rank: "Junior lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/abdullahi-isah.jpg`,
    qualifications: ["B. Eng (FUT Minna)"],
    professionalQualifications: ["MNSE"],
    publications: "",
    researchInterests: ["Structural engineer", "Compressive strength of concrete"],
    specialties: ["B.Eng (Civil Engineering)"],
    awards: [],
    email: "isahkatun@fedpolybida.edu.ng",
    phone: "08067849926",
    driveFileId: "1lcf-lpXsURsD7lcLJycYWFSH1UHUJk7_",
    slug: "abdullahi-isah",
  },
  {
    id: 30,
    title: "ENGR.",
    name: "OYEBANJI TAOFEEK OYETUNDE",
    rank: "LECTURER I",
    image: `${CIVIL_STAFF_IMAGE_BASE}/oyebanji-taofeek-oyetunde.jpg`,
    qualifications: ["B.Eng (FUT Minna)"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "",
    researchInterests: ["HIGHWAY AND TRANSPORTATION", "MATERIALS"],
    specialties: ["B.Eng (Civil Engineering)"],
    awards: [],
    email: "oyebanji.taofeek@fedpolybida.edu.ng",
    phone: "07034595380",
    driveFileId: "1hWzjMiYmV3IRsdkw_F-yjoAKaFBMVVmQ",
    slug: "oyebanji-taofeek-oyetunde",
  },
  {
    id: 31,
    title: "Engr.",
    name: "Alhaji Minin Ndayahaya",
    rank: "Senior Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/alhaji-minin-ndayahaya.jpg`,
    qualifications: ["M. Eng (FUT Minna)"],
    professionalQualifications: ["MNSE", "COREN"],
    publications: "12",
    researchInterests: ["Structural Engineering", "Water Resources Engineering", "Transportation Engineering"],
    specialties: ["B.Eng (Civil Engineering)", "M.Eng (Structural Engineering)"],
    awards: [],
    email: "alhaji.ndayahaya@fedpolybida.edu.ng",
    phone: "08036592203",
    driveFileId: "11t8EQp1_yiTk02qR3f-7KzSkePHkbbpQ",
    slug: "alhaji-minin-ndayahaya",
  },
  {
    id: 32,
    title: "Engr",
    name: "Eng’r Mahmud Mohammed bello",
    rank: "Senior lecturer",
    image: "/images/default-staff.jpg",
    qualifications: ["B.eng, meng futminna"],
    professionalQualifications: ["Coren"],
    publications: "Outstanding acadamic publication   Upto 20 publication",
    researchInterests: ["B.eng,M.eng civil engineering", "Meng Geotechnical engineering", "Phd Geotechnical engineering", "water effect on d compressive strength properties of concrete with 0.5,0.6 water cement ratio", "2 Quality Assessment of Package Water", "D comparison of engineering properties of ironwood,bamboo and ordinary timber as construction materials", "Impact of road bumps on traffic flow properties for selected section in poly", "Investigation into d effect of abattoir waste on ground water", "Quality assessment of packaged water produced in bida", "Geotechnical evaluation of rice husk ash as a stabilizer for laterite soil in road construction"],
    specialties: ["Civil engineering"],
    awards: ["Outstanding acadamic publication   Upto 20 publication"],
    email: "Mahmudbellomohammed@fedpoly.edu.ng",
    phone: "08036991030",
    driveFileId: "1h-pu9IPXtuVH8zOKWGP16TItrh3axdg7",
    slug: "engr-mahmud-mohammed-bello",
  },
  {
    id: 33,
    title: "Engr",
    name: "Aliyu Alhaji Musa",
    rank: "Senior Technologist",
    image: `${CIVIL_STAFF_IMAGE_BASE}/aliyu-alhaji-musa.jpg`,
    qualifications: ["HND FED POLY (BIRNIN KEBBI) PGD in view"],
    professionalQualifications: ["NATE"],
    publications: "Nil",
    researchInterests: ["Highway Engineering", "Investigation on asphaltic concrete"],
    specialties: ["Civil Engineering (Highway/Transportation)"],
    awards: [],
    email: "hsnaminaaliyu@gmail.com",
    phone: "08037007936",
    driveFileId: "1Flm3PBGu75cmCX2s144maRb9sV_yavGl",
    slug: "aliyu-alhaji-musa",
  },
  {
    id: 34,
    title: "Engr.",
    name: "Engr.Anurunwa Nnamdi Justice",
    rank: "Principal Lecturer",
    image: `${CIVIL_STAFF_IMAGE_BASE}/engr-anurunwa-nnamdi-justice.jpg`,
    qualifications: ["B.Eng,MEng(FUT Minna)"],
    professionalQualifications: ["MNATE", "MNSE", "COREN"],
    publications: "Over 15",
    researchInterests: ["Water Resources and Environmental Engineering", "Waste Water Engineering"],
    specialties: ["B.Eng Civil Engineering", "M.Eng ( Water Resources and Environmental Engineering", "Inview"],
    awards: [],
    email: "anurunwa.justice@fedpolybida.edu.ng",
    phone: "08068935830",
    driveFileId: "1oxvYeipNIjWaiSuH9nPgN9GlRc7Hc8Cl",
    slug: "engr-anurunwa-nnamdi-justice",
  },
  {
    id: 35,
    title: "Tgst",
    name: "Edota Umaru",
    rank: "Assistant Chief Instructor",
    image: `${CIVIL_STAFF_IMAGE_BASE}/edota-umaru.jpg`,
    qualifications: ["B Eng (Kwasu Ilorin)"],
    professionalQualifications: ["NATE"],
    publications: "15",
    researchInterests: ["Structure", "Material"],
    specialties: ["B. Eng Civil Engineering"],
    awards: ["Nil"],
    email: "Umaru Edota@fedpolybida.edu.ng",
    phone: "08065686051",
    driveFileId: "1TSBZ3FrMWcW9DHGxGbejs1H-gVYYcwu_",
    slug: "edota-umaru",
  },
  {
    id: 36,
    title: "Tgst",
    name: "Hamzat Shuaibu Abdulrahman",
    rank: "Assistant Chief Instructor",
    image: `${CIVIL_STAFF_IMAGE_BASE}/hamzat-shuaibu-abdulrahman.jpg`,
    qualifications: ["B.Eng. (FUT Minna)"],
    professionalQualifications: ["NATE"],
    publications: "5",
    researchInterests: ["Water", "Transportation"],
    specialties: ["B.Eng. Civil Engineering"],
    awards: ["Nil"],
    email: "Abdulrahman.@fedpolybida.edu.ng",
    phone: "07068163953",
    driveFileId: "12hX77t3Kbt5wa9s6w57hq8F0bP5jHrW3",
    slug: "hamzat-shuaibu-abdulrahman",
  },
  {
    id: 37,
    title: "Engr",
    name: "Shuaibu Usman bala",
    rank: "Senior technologist",
    image: `${CIVIL_STAFF_IMAGE_BASE}/shuaibu-usman-bala.jpg`,
    qualifications: ["Hnd  (fpb)"],
    professionalQualifications: ["Niset"],
    publications: "",
    researchInterests: ["The comparative analysis of the strength of concrete made from different size of aggregate", "Comparative analysis of different methods of concrete curing on strength development"],
    specialties: ["Hnd civil engineering"],
    awards: [],
    email: "Shuaibubalausman@yahoo.com",
    phone: "07060415631",
    driveFileId: "1En9xiu52Y78BBo9Hb8a7isLd5X_KadNF",
    slug: "shuaibu-usman-bala",
  },
];
